import { object, string } from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, Shelf } from '@chaser/components';
import ChaserToken from '../../../../../components/ChaserToken/index';
import usePush from '../../../../../hooks/usePush';
import SettingsService from '../../../../../services/settings-service';
import style from './EmailVerified.module.scss';
import LoadingPlaceholders from '@/components/LoadingPlaceholders';

const EmailVerified = ({ user, shortCode }) => {
  const { execute, loading, success, reset } = usePush(SettingsService.inviteUser);

  return (
    <LoadingPlaceholders rows={1} loading={user.isLoading}>
      <Shelf gap="xsmall" className={style.wrapper}>
        <div>{user.email}</div>
        {!user.verified && <ChaserToken intent="warning">Not verified</ChaserToken>}
        <ButtonGroup className={style.buttons}>
          {!user.verified && (
            <Button
              appearance="secondary"
              loading={loading}
              success={success}
              successMessage="Invite sent"
              onClick={() => {
                execute(shortCode, user.email, [], true);
              }}
              onReset={reset}
              size="narrow"
              resetTimeout={30000}
              className={style.verifyButton}
            >
              Resend Invitation
            </Button>
          )}
        </ButtonGroup>
      </Shelf>
    </LoadingPlaceholders>
  );
};

EmailVerified.propTypes = {
  user: object.isRequired,
  shortCode: string.isRequired,
};

export default EmailVerified;
